export default "__VITE_ASSET__C15IvNRf__"